export default __webpack_public_path__ + "static/media/kirsten_young.a5e4d064.m4a";